// App.js
import React from 'react';
import AppRoutes from './AppRoutes'; // Import AppRoutes

const App = () => {
  return <AppRoutes />; // Render AppRoutes
};

export default App;

